var map = {
	"./StockScreen1.vue": [
		"4fc1",
		"chunk-2d0ccf56"
	],
	"./StockScreen2.vue": [
		"5f2e",
		"chunk-2d0d3dfa"
	],
	"./StockScreen3.vue": [
		"b5c7",
		"chunk-2d21007d"
	],
	"./StockScreen4.vue": [
		"67f6",
		"chunk-2d0d0807"
	],
	"./StockScreen5.vue": [
		"f4e2",
		"chunk-2d22ce71"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "a3f2";
module.exports = webpackAsyncContext;